export const DEFAULT_TITLE = 'ワイン通販のENOTECA(エノテカ)';
export const TEMPLATE_TITLE = ' | エノテカ - ワイン通販';
